import URL from '../../../constants/ApiEndPoints';
import { uploadFile } from '../../../utils/fileSystem';

const designUploadService = (payload: FormData) => uploadFile(URL.uploadDesign, payload);

export default designUploadService;
